import { shallowEqual } from 'react-redux';

import { useAppSelector } from 'utils/redux/useAppSelector';

import { ConversationHeaderCsatDropdown } from './components/csatDropdown/csatDropdown';

const messagesContainType = (messages, messageType: string) =>
  messages.some(({ type }) => type === messageType);

function getCsatDisabledState(
  messages,
): 'Offered' | 'Cancelled' | 'Answered' | undefined {
  if (messagesContainType(messages, 'conversation:rated')) {
    return 'Answered';
  }
  if (messagesContainType(messages, 'conversation:rating_offered')) {
    return 'Offered';
  }
  if (messagesContainType(messages, 'conversation:rating_cancelled')) {
    return 'Cancelled';
  }
  return undefined;
}

export const ConversationHeaderCsatMenu = (): JSX.Element | null => {
  const [
    { isAssignedToMe, messages },
    { initial_channel: channel, attributes },
    asyncStatus,
  ] = useAppSelector(
    (state) => [
      state.conversation.metaConversation,
      state.conversation.metaConversation.conversation,
      state.conversation.asyncStatus,
    ],
    shallowEqual,
  );
  const showSatisfactionLanguageDropdown =
    isAssignedToMe &&
    attributes?.csat_eligible === 'true' &&
    channel &&
    ['email', 'contactform', 'pstnphone', 'callback'].includes(channel);
  const isLoading =
    asyncStatus.getConversation === 'loading' ||
    asyncStatus.claim === 'loading' ||
    asyncStatus.close === 'loading';

  if (!showSatisfactionLanguageDropdown || isLoading) {
    return null;
  }

  const disabledText = getCsatDisabledState(messages);

  return <ConversationHeaderCsatDropdown disabledText={disabledText} />;
};
